export enum SESSION_STORAGE_KEYS {
  TOKEN = 'token',
  CURRENT_USER_BASIC_DATA = 'current-user-basic-data',
  CURRENT_USER_DATA = 'current-user-data',
  USER_ROLE = 'user-role',
  IS_MOTO_ACTIVE = 'is-moto-active',

  DEPOSITS_SELECTED_EXTERNAL_BANK = 'selected-external-bank',

  DEPOSITS_CLICKED_ACCOUNT = 'deposit-clicked-account',
  DEPOSITS_CLICKED_ACCOUNT_TYPE = 'deposit-clicked-account-type',

  ECOMMERCE_TOKEN_KEY = 'ecommerce-token',
  ECOMMERCE_LAST_CART_ID = 'ecommerce-last-cart-id',
  ECOMMERCE_PROMO_KEY = 'ecommerce-promo-key',
  ECOMMERCE_EMBEDDED_CHECKOUT_URL = 'embedded-checkout-url',
  ECOMMERCE_IS_ECOMMERCE_PROCESSING = 'is-ecommerce-processing',
  ECOMMERCE_IS_ECOMMERCE_DONE = 'is-ecommerce-done',

  ENTITY_DETAILS = 'entity-details',
  IS_SIGNING_UP = 'is-signing-up',

  ONBOARDING_ENTITY_DATA = 'onboarding-entity-data',
  ONBOARDING_INITIAL_SEARCH_DATA = 'onboarding-initial-search-data',
  ONBOARDING_METADATA = 'onboarding-metadata',
  ONBOARDING_LINK_CARD_DATA = 'onboarding-link-data',
  ONBOARDING_LINK_CARD_ERROR = 'onboarding-link-error',
  ONBOARDING_LINK_CARD_COLOR = 'onboarding-link-color',
  ONBOARDING_CUSTOMERS_TEMP_DATA = 'customers-temp-data',
  ONBOARDING_CUSTOMERS_INITIAL_MEMBERS_DATA = 'customers-initial-members-data',
  ONBOARDING_CUSTOMERS_CURRENT_CUSTOMER_TEMP_ID = 'customers-current-customer-temp-id',
  ONBOARDING_COMPANY_SEARCH_UNSUPPORTED_ABN_OR_ACNS = 'company-search-unsupported-abn-or-acns',
  ONBOARDING_COMPANY_SEARCH_INACTIVE_ABN_OR_ACNS = 'company-search-inactive-abn-or-acns',
  ONBOARDING_COMPANY_SEARCH_THIRD_PARTY_ERROR = 'company-search-third-party-error',
  ONBOARDING_IS_GOVERNMENT_CUSTOMER_UPDATED = 'onboarding-is-government-customer-updated',

  SITES_NEW_SITES = 'new-sites',
  SITES_LAST_SELECTED_SITE_ID = 'last-site',

  ACCOUNTS_LIST = 'accounts-list',
  ACCOUNTS_LAST_SELECTED = 'last-selected-account',
  ACCOUNTS_LAST_SELECTED_ID = 'last-selected-id',
  ACCOUNTS_LAST_SELECTED_TRANSACTION = 'last-selected-transaction',
  ACCOUNTS_LAST_SELECTED_TRANSACTION_DETAILS = 'last-selected-transaction-details',

  CARDS_ADD_ACCOUNT = 'card-add-acc',
  CARDS_ADD_ERROR = 'card-add-err',
  CARDS_COLOR = 'card-color',
  CARDS_SEQUENCE = 'card-seq',
  CARDS_SELECTED_CARD = 'selected-card',

  FILTER_SELECTED_DATES = 'filter-selected-dates',
  PREVIOUS_PATH = 'previous-path',

  AUTH_E2E_IN_PROGRESS = 'auth-e2e-in-progress',

  ADMIN_KYC_IS_VERIFICATION_SKIPPED = 'is-id-verification-skipped',

  KYC_DATA = 'kyc-data',

  ZELLER_SESSION_ID = 'zellerSessionId',

  HAS_SEEN_PUSH_APP_MODAL = 'has-seen-push-app-modal',
  HAS_SEEN_OVERIVEW_BANNER = 'has-seen-overview-banner',

  HIDE_OVERVIEW_BANNER = 'hide-overview-banner',
}
